/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@angular/forms';
import * as i3 from '../../../app/components/add-discount-form';
import * as i4 from '@ngrx/store/src/store';
import * as i5 from '@ngrx/effects/src/actions';
import * as i6 from '../../../app/services/modal';
const styles_AddDiscountFormComponent:any[] = ([] as any[]);
export const RenderType_AddDiscountFormComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_AddDiscountFormComponent,data:{}});
function View_AddDiscountFormComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'span',[['class',
      'adf__type-attr multiplier']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(1,(null as any),['','% ']))],(null as any),(_ck,
      _v) => {
    const currVal_0:any = ((<any>_v.parent).context.$implicit.multiplier * 100);
    _ck(_v,1,0,currVal_0);
  });
}
function View_AddDiscountFormComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'span',[['class',
      'adf__type-attr campus']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(1,(null as any),['(',')']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.getCampus((<any>_v.parent).context.$implicit.campusId).name;
    _ck(_v,1,0,currVal_0);
  });
}
function View_AddDiscountFormComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),7,'li',[['class',
      'adf__type']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.clickedDiscountType(_v.context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(1,278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,
      i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,
      'ngClass']},(null as any)),i0.ɵpod(2,{'selected':0}),(_l()(),i0.ɵted(3,(null as any),
      ['',' '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_AddDiscountFormComponent_2)),i0.ɵdid(5,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,
      i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵand(16777216,(null as any),
      (null as any),1,(null as any),View_AddDiscountFormComponent_3)),i0.ɵdid(7,16384,
      (null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
      (null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = 'adf__type';
    const currVal_1:any = _ck(_v,2,0,_co.isDiscountTypeSelected(_v.context.$implicit));
    _ck(_v,1,0,currVal_0,currVal_1);
    const currVal_3:any = _v.context.$implicit.multiplier;
    _ck(_v,5,0,currVal_3);
    const currVal_4:any = _v.context.$implicit.campusId;
    _ck(_v,7,0,currVal_4);
  },(_ck,_v) => {
    const currVal_2:any = _v.context.$implicit.description;
    _ck(_v,3,0,currVal_2);
  });
}
function View_AddDiscountFormComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),11,'div',[['class',
      'input-row']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(1,0,(null as any),(null as any),10,'div',[['class','input-group']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(2,0,(null as any),(null as any),9,'div',[['class','ig__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(3,0,(null as any),(null as any),6,'input',[['id','fixed-amount'],
          ['type','number']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend'],
              [(null as any),'change']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,4)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,4).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,4)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,4)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('change' === en)) {
              const pd_4:any = ((<any>i0.ɵnov(_v,5).onChange($event.target.value)) !== false);
              ad = (pd_4 && ad);
            }
            if (('input' === en)) {
              const pd_5:any = ((<any>i0.ɵnov(_v,5).onChange($event.target.value)) !== false);
              ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
              const pd_6:any = ((<any>i0.ɵnov(_v,5).onTouched()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.params.fixedAmount = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(4,16384,(null as any),0,i2.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵdid(5,16384,(null as any),0,i2.ɵbc,[i0.Renderer2,i0.ElementRef],
          (null as any),(null as any)),i0.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,
          (p0_0:any,p1_0:any) => {
            return [p0_0,p1_0];
          },[i2.DefaultValueAccessor,i2.ɵbc]),i0.ɵdid(7,671744,(null as any),0,i2.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(9,16384,(null as any),0,
          i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),(_l()(),i0.ɵeld(10,
          0,(null as any),(null as any),1,'label',[['for','fixed-amount']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted(-1,
          (null as any),['Fixed amount']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_7:any = _co.params.fixedAmount;
    _ck(_v,7,0,currVal_7);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,9).ngClassUntouched;
    const currVal_1:any = i0.ɵnov(_v,9).ngClassTouched;
    const currVal_2:any = i0.ɵnov(_v,9).ngClassPristine;
    const currVal_3:any = i0.ɵnov(_v,9).ngClassDirty;
    const currVal_4:any = i0.ɵnov(_v,9).ngClassValid;
    const currVal_5:any = i0.ɵnov(_v,9).ngClassInvalid;
    const currVal_6:any = i0.ɵnov(_v,9).ngClassPending;
    _ck(_v,3,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
export function View_AddDiscountFormComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),46,'div',[['class',
      'add-discount-form']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),45,'div',[['class',
      'adf__content-wrapper']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(2,0,(null as any),(null as any),1,'h1',[['class',
      'adf__header']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['Add discount'])),(_l()(),i0.ɵeld(4,0,(null as any),
          (null as any),2,'ul',[['class','adf__types two-column']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_AddDiscountFormComponent_1)),i0.ɵdid(6,
          802816,(null as any),0,i1.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i0.ɵeld(7,0,(null as any),
          (null as any),30,'div',[['class','input-row']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(8,0,(null as any),
          (null as any),9,'div',[['class','input-group start-date']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(9,
          0,(null as any),(null as any),8,'div',[['class','ig__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(10,0,(null as any),(null as any),5,'input',[['id','start-date'],
          ['type','date']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i3.AddDiscountFormComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,11)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,11).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,11)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,11)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_4:any = ((<any>_co.setDate('startDate',$event)) !== false);
              ad = (pd_4 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(11,16384,(null as any),0,i2.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.DefaultValueAccessor]),i0.ɵdid(13,671744,(null as any),0,i2.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(15,16384,(null as any),
          0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),(_l()(),
          i0.ɵeld(16,0,(null as any),(null as any),1,'label',[['for','start-date']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['Start date'])),(_l()(),i0.ɵeld(18,0,(null as any),
          (null as any),9,'div',[['class','input-group end-date']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(19,0,(null as any),
          (null as any),8,'div',[['class','ig__content-wrapper']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(20,0,(null as any),
          (null as any),5,'input',[['id','end-date'],['type','date']],[[2,'ng-untouched',
              (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
              [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                  (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i3.AddDiscountFormComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,21)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,21).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,21)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,21)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_4:any = ((<any>_co.setDate('endDate',$event)) !== false);
              ad = (pd_4 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(21,16384,(null as any),0,i2.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.DefaultValueAccessor]),i0.ɵdid(23,671744,(null as any),0,i2.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(25,16384,(null as any),
          0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),(_l()(),
          i0.ɵeld(26,0,(null as any),(null as any),1,'label',[['for','end-date']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['End date'])),(_l()(),i0.ɵeld(28,0,(null as any),
          (null as any),9,'div',[['class','input-group transaction-date']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(29,
          0,(null as any),(null as any),8,'div',[['class','ig__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(30,0,(null as any),(null as any),5,'input',[['id','transaction-date'],
          ['type','date']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i3.AddDiscountFormComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,31)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,31).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,31)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,31)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_4:any = ((<any>_co.setDate('transactionDate',$event)) !== false);
              ad = (pd_4 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(31,16384,(null as any),0,i2.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.DefaultValueAccessor]),i0.ɵdid(33,671744,(null as any),0,i2.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(35,16384,(null as any),
          0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),(_l()(),
          i0.ɵeld(36,0,(null as any),(null as any),1,'label',[['for','transaction-date']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['Transaction date'])),(_l()(),i0.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_AddDiscountFormComponent_4)),
      i0.ɵdid(39,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵeld(40,0,(null as any),(null as any),
          6,'div',[['class','adf__actions']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵeld(41,0,(null as any),(null as any),
          5,'div',[['class','input-group']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵeld(42,0,(null as any),(null as any),
          4,'div',[['class','ig__content-wrapper']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵeld(43,0,(null as any),(null as any),
          3,'button',([] as any[]),[[8,'disabled',0]],[[(null as any),'click']],(_v,
              en,$event) => {
            var ad:boolean = true;
            var _co:i3.AddDiscountFormComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedSubmit()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(44,278528,(null as any),0,i1.NgClass,
          [i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{ngClass:[0,
              'ngClass']},(null as any)),i0.ɵpod(45,{'disabled':0}),(_l()(),i0.ɵted(-1,
          (null as any),['Apply discount']))],(_ck,_v) => {
    var _co:i3.AddDiscountFormComponent = _v.component;
    const currVal_0:any = _co.discountTypes;
    _ck(_v,6,0,currVal_0);
    const currVal_8:any = _co.startDateStr;
    _ck(_v,13,0,currVal_8);
    const currVal_16:any = _co.endDateStr;
    _ck(_v,23,0,currVal_16);
    const currVal_24:any = _co.transactionDateStr;
    _ck(_v,33,0,currVal_24);
    const currVal_25:any = _co.isFixedDiscountSelected();
    _ck(_v,39,0,currVal_25);
    const currVal_27:any = _ck(_v,45,0,!_co.isFormValid());
    _ck(_v,44,0,currVal_27);
  },(_ck,_v) => {
    var _co:i3.AddDiscountFormComponent = _v.component;
    const currVal_1:any = i0.ɵnov(_v,15).ngClassUntouched;
    const currVal_2:any = i0.ɵnov(_v,15).ngClassTouched;
    const currVal_3:any = i0.ɵnov(_v,15).ngClassPristine;
    const currVal_4:any = i0.ɵnov(_v,15).ngClassDirty;
    const currVal_5:any = i0.ɵnov(_v,15).ngClassValid;
    const currVal_6:any = i0.ɵnov(_v,15).ngClassInvalid;
    const currVal_7:any = i0.ɵnov(_v,15).ngClassPending;
    _ck(_v,10,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
    const currVal_9:any = i0.ɵnov(_v,25).ngClassUntouched;
    const currVal_10:any = i0.ɵnov(_v,25).ngClassTouched;
    const currVal_11:any = i0.ɵnov(_v,25).ngClassPristine;
    const currVal_12:any = i0.ɵnov(_v,25).ngClassDirty;
    const currVal_13:any = i0.ɵnov(_v,25).ngClassValid;
    const currVal_14:any = i0.ɵnov(_v,25).ngClassInvalid;
    const currVal_15:any = i0.ɵnov(_v,25).ngClassPending;
    _ck(_v,20,0,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15);
    const currVal_17:any = i0.ɵnov(_v,35).ngClassUntouched;
    const currVal_18:any = i0.ɵnov(_v,35).ngClassTouched;
    const currVal_19:any = i0.ɵnov(_v,35).ngClassPristine;
    const currVal_20:any = i0.ɵnov(_v,35).ngClassDirty;
    const currVal_21:any = i0.ɵnov(_v,35).ngClassValid;
    const currVal_22:any = i0.ɵnov(_v,35).ngClassInvalid;
    const currVal_23:any = i0.ɵnov(_v,35).ngClassPending;
    _ck(_v,30,0,currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,
        currVal_23);
    const currVal_26:boolean = !_co.isFormValid();
    _ck(_v,43,0,currVal_26);
  });
}
export function View_AddDiscountFormComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'add-discount-form',
      ([] as any[]),(null as any),(null as any),(null as any),View_AddDiscountFormComponent_0,
      RenderType_AddDiscountFormComponent)),i0.ɵdid(1,245760,(null as any),0,i3.AddDiscountFormComponent,
      [i4.Store,i5.Actions,i6.ModalService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AddDiscountFormComponentNgFactory:i0.ComponentFactory<i3.AddDiscountFormComponent> = i0.ɵccf('add-discount-form',
    i3.AddDiscountFormComponent,View_AddDiscountFormComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/$$_gendir/app/components/add-discount-form.ngfactory.ts